module.exports = __webpack_public_path__ + "img/mz.dac5f7e.svg";